import React, { useState, useContext, useEffect } from 'react';
import AppConfigurationService from '../../../services/app-configuration-service/app-configuration-service';
import { Chevron } from '../../common';
import { useImportantInfoAccordionContent } from './hooks/use-important-info-accordion';
import './important-info-accordion.scss';
import {
    displayEUFooter,
    hideEUFooter,
} from '../../../components/utils/syndicate-util/syndicate-util';
import { EU_COUNTRIES, BRAND } from '../../../constants';
import ServerContext from '../../../contexts/serverContext';
interface Props {
    aemFolder?: string;
    expanded?: boolean;
    accordionContent?: string;
}
const ImportantInfoAccordion = (props: Props) => {
    const [expanded, setExpanded] = useState<boolean>(
        props.expanded ? props.expanded : false
    );
    const content = useImportantInfoAccordionContent(
        props.aemFolder,
        props.accordionContent
    );
    const { brand } = new AppConfigurationService();
    const serverContext = useContext(ServerContext);
    useEffect(() => {
        if (
            brand === 'ford' &&
            EU_COUNTRIES.includes(serverContext.currentRegionCode)
        ) {
            content ? displayEUFooter() : hideEUFooter();
        }
    }, [content]);
    return (
        <>
            {content && (
                <div className="important-info-accordion">
                    <button
                        aria-label={content.accordionTitle}
                        aria-expanded={expanded ? 'true' : 'false'}
                        onClick={() => setExpanded(!expanded)}
                        className="info-accordion-header"
                    >
                        <h3 className="accordion-title">
                            {content.accordionTitle}
                        </h3>
                        <Chevron
                            className="accordion-chevron"
                            direction={expanded ? 'up' : 'down'}
                            color={
                                brand === BRAND.lincoln.LONG_NAME
                                    ? '#f26147'
                                    : ''
                            }
                        />
                    </button>
                    <div
                        className={`accordion-content ${
                            expanded ? '' : 'hide'
                        }`}
                    >
                        {expanded && content.accordionContent && (
                            <div
                                className={`accordion-content-text`}
                                dangerouslySetInnerHTML={{
                                    __html: content.accordionContent,
                                }}
                            />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};
export default ImportantInfoAccordion;
